require( 'lemurJS/js/src/lemurFunctions.js' );

lemur.itoc( 'ps', {} );
ps.youtube_api_key = ajax_object.youtube_api_key;

jQuery.fn.show2 = function() {
	return this.css( 'visibility', 'visible' );
};

jQuery.fn.hide2 = function() {
	return this.css( 'visibility', 'hidden' );
};

jQuery.fn.visibilityToggle = function() {
	return this.css( 'visibility', function( i, visibility ) {
		return ( visibility === 'visible' ) ? 'hidden' : 'visible';
	} );
};

jQuery( document ).ready( function( $ ) {
	$( '[name=btn_category]' ).val( 'Add a new category' );
} );

function strpos( haystack, needle, offset ) {
	//  discuss at: http://locutus.io/php/strpos/
	// original by: Kevin van Zonneveld (http://kvz.io)
	// improved by: Onno Marsman (https://twitter.com/onnomarsman)
	// improved by: Brett Zamir (http://brett-zamir.me)
	// bugfixed by: Daniel Esteban
	//   example 1: strpos('Kevin van Zonneveld', 'e', 5)
	//   returns 1: 14

	var i = ( haystack + '' )
		.indexOf( needle, ( offset || 0 ) );
	return i === -1 ? false : i;
}

var setYouTubeInfo, parseresults, setYouTubetitle, setWebsiteMeta, getVideoInfo;

getVideoInfo = function( url, callbackFunction ) {
	var videoinfo = {
		status: 'error',
		keywords: {},
		thumbnail: {},
	};

	if ( strpos( url, 'youtube' ) > 0 ) {
		console.log( 'Getting youtube info' );

		var videoid = url.match( /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/ );
		console.log( videoid );
		jQuery.ajax( {

			url: 'https://www.googleapis.com/youtube/v3/videos?id=' + videoid[ 1 ] + '&key=' + ps.youtube_api_key + '&fields=items(snippet(title,description,thumbnails,tags))&part=snippet',
			//    data: myData,
			type: 'GET',
			//    crossDomain: true,
			dataType: 'jsonp',
			success: function( data ) {
				console.dir( data );

				for ( var i = 0; i < data.items[ 0 ].snippet.tags.length; ++i ) {
					videoinfo.keywords[ i ] = data.items[ 0 ].snippet.tags[ i ];
				}

				videoinfo.title = data.items[ 0 ].snippet.title;
				videoinfo.description = data.items[ 0 ].snippet.description;
				videoinfo.thumbnail = {
					small: 'small',
					medium: 'med',
					large: 'large',
				};
				videoinfo.thumbnail.small = data.items[ 0 ].snippet.thumbnails.standard.url;
				videoinfo.thumbnail.medium = data.items[ 0 ].snippet.thumbnails.standard.url;
				videoinfo.thumbnail.large = data.items[ 0 ].snippet.thumbnails.standard.url;

				videoinfo.embed = '<iframe id="player" type="text/html" width="400" height="400" src="http://www.youtube.com/embed/' + videoid[ 1 ] + '" frameborder="0"></iframe>';

				videoinfo.status = 'success';

				if ( callbackFunction ) {
					console.log( 'callback' );
					callbackFunction( videoinfo );
				} else {
					return videoinfo;
				}
			},
			error: function() {
				if ( callbackFunction ) {
					console.log( 'callback - error' );
					callbackFunction( videoinfo );
				} else {
					return videoinfo;
				}
			},
			//    beforeSend: setHeader
		} );

		//               jQuery.getJSON('https://www.youtube.com/oembed?url=http://www.youtube.com/watch?v=ojCkgU5XGdg&format=json',function(data,status,xhr){
		//  alert(data.title);
		// data contains the JSON-Object below
		//});
	} else if ( strpos( url, 'vimeo' ) > 0 ) {
		console.log( 'Getting vimeo info' );

		//var url = "http://www.vimeo.com/7058755";
		var regExp = /https?:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;

		var match = url.match( regExp );

		if ( match ) {
			console.log( 'vimeo id: ' + match[ 2 ] );

			jQuery.ajax( {

				url: 'http://vimeo.com/api/v2/video/' + match[ 2 ] + '.json',
				//    data: myData,
				type: 'GET',
				//    crossDomain: true,
				dataType: 'json',
				success: function( data ) {
					console.dir( data );
					videoinfo.keywords = data[ 0 ].tags.split( ',' );

					videoinfo.title = data[ 0 ].title;
					videoinfo.description = data[ 0 ].description;
					videoinfo.thumbnail = {};
					videoinfo.thumbnail.small = data[ 0 ].thumbnail_large;
					videoinfo.thumbnail.medium = data[ 0 ].thumbnail_medium;
					videoinfo.thumbnail.large = data[ 0 ].thumbnail_large;

					videoinfo.status = 'success';

					jQuery.ajax( {

						url: 'http://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/' + match[ 2 ] + '.json',
						//    data: myData,
						type: 'GET',
						//    crossDomain: true,
						dataType: 'json',
						success: function( data2 ) {
							console.log( 'getting embed' );
							console.dir( data2 );
							videoinfo.embed = data2.html;

							if ( callbackFunction ) {
								console.log( 'callback' );
								callbackFunction( videoinfo );
							} else {
								return videoinfo;
							}
						},
						error: function() {
							if ( callbackFunction ) {
								console.log( 'callback - error' );
								callbackFunction( videoinfo );
							} else {
								return videoinfo;
							}
						},
						//
					} );
				},
				error: function() {
					if ( callbackFunction ) {
						console.log( 'callback - error' );
						callbackFunction( videoinfo );
					} else {
						return videoinfo;
					}
				},
				//    beforeSend: setHeader
			} );
		} else {
			console.log( 'not a vimeo url, no id found' );
		}
	} else {
		console.log( 'no good' );

		if ( callbackFunction ) {
			console.log( 'callback' );
			callbackFunction( videoinfo );
		} else {
			videoinfo = false;
			return videoinfo;
		}
	}
};

getYouTubeInfo = function( url ) {
	if ( strpos( url, 'youtube' ) > 0 ) {
		var videoid = url.match( /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/ );
		jQuery.ajax( {

			url: 'https://www.googleapis.com/youtube/v3/videos?id=' + videoid + '&key=AIzaSyBv-Ulsg2kwwxUq2JOfvdIM5GOWG52iOJE&fields=items(snippet(title,description,thumbnails,tags))&part=snippet',
			//    data: myData,
			type: 'GET',
			//    crossDomain: true,
			dataType: 'jsonp',
			success: function( data ) {
				//	var info = new Array();
				//	info['title'] = data.items[0].snippet.title;
				//	info['thumb_url'] = data.items[0].snippet.thumbnails.default.url;
				//console.log('Got this from the server: ' + data);
				console.dir( data );
				var obj = {
					keywords: {},
				};

				//var obj = {};
				for ( var i = 0; i < data.items[ 0 ].snippet.tags.length; ++i ) {
					obj.keywords[ i ] = data.items[ 0 ].snippet.tags[ i ];
				}

				jQuery( '[id^=' + titlefieldid + ']' ).val( data.items[ 0 ].snippet.title );
				jQuery( '[id^=' + descid + ']' ).val( data.items[ 0 ].snippet.description );

				jQuery( '#webpage_thumb_div' ).html( '<div class="overlay"></div>' +
'<img id="webpage_thumb" src="' + data.items[ 0 ].snippet.thumbnails.standard.url + '">' +
'<span class="click">Click to Replace</span>' );
				//jQuery('#webpage_thumb').attr("src","/wp-includes/js/tinymce/skins/lightgray/img/loader.gif");

				jQuery( document ).ready( function( $ ) {
					$( '#webpage_thumb_div .click' ).mouseover( function() {
						$( '.overlay' ).animate( {
							opacity: 0.5,
						}, 100 );
					} ).mouseout( function() {
						$( '.overlay' ).animate( {
							opacity: 0,
						}, 100 );
					} );

					$( '#webpage_thumb_div .click' ).click( function() {
						$( '#web_post_cred_thumb_div' ).show( 100 );

						$( '#webpage_thumb_div' ).hide( 100 );
						$( 'input[name=web_post_auto_thumb]' ).attr( 'value', '' );
					} );
				} );

				//jQuery('#webpage_thumb').attr("src",data.items[0].snippet.thumbnails.standard.url);
				jQuery( 'input[name=web_post_auto_thumb]' ).attr( 'value', data.items[ 0 ].snippet.thumbnails.standard.url );

				if ( obj.hasOwnProperty( 'keywords' ) ) {
					//jQuery('[id^='+tagid+']').val(obj.keywords);
					//var thiz = $(".cred-taxonomy.cred-taxonomy-post_tag .btn.btn-default.wpt-taxonomy-add-new.js-wpt-taxonomy-add-new.wpt-form-button.form-button");
					//  var thiz = $(".cred-taxonomy.cred-taxonomy-post_tag .btn.btn-default.wpt-taxonomy-add-new.js-wpt-taxonomy-add-new.wpt-form-button.form-button");
					//        taxonomy = thiz.data("taxonomy");
					//setTaxonomy("post_tag", "test");

					var taxonomy = 'post_tag';
					var form = jQuery( '.cred-taxonomy.cred-taxonomy-post_tag .btn.btn-default.wpt-taxonomy-add-new.js-wpt-taxonomy-add-new.wpt-form-button.form-button' ).closest( 'form' );
					//var tmp_tax = jQuery("input[name=tmp_" + taxonomy + "]", form).val();
					console.log( obj.keywords );
					console.log( obj.keywords );
					//var tmp_tax = obj.keywords;
					var tmp_tax = jQuery.map( obj.keywords, function( value, index ) {
						return [ value ];
					} );
					//var rex = /<\/?(a|abbr|acronym|address|applet|area|article|aside|audio|b|base|basefont|bdi|bdo|bgsound|big|blink|blockquote|body|br|button|canvas|caption|center|cite|code|col|colgroup|data|datalist|dd|del|details|dfn|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hgroup|hr|html|i|iframe|img|input|ins|isindex|kbd|keygen|label|legend|li|link|listing|main|map|mark|marquee|menu|menuitem|meta|meter|nav|nobr|noframes|noscript|object|ol|optgroup|option|output|p|param|plaintext|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|source|spacer|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video|wbr|xmp)\b[^<>]*>/ig;
					//tmp_tax = _.escape(tmp_tax.replace(rex, "")).trim();
					//if (tmp_tax.trim() === "")
					//return;
					var tax = jQuery( 'input[name=' + taxonomy + ']', form ).val();
					//var arr = tax.toString();
					var arr = tax.split( ',' );
					if ( jQuery.inArray( tmp_tax, arr ) !== -1 ) {
						return;
					}
					var toadd = ( tax === '' ) ? tmp_tax : tax + ',' + tmp_tax;
					jQuery( 'input[name=' + taxonomy + ']', form ).val( toadd );
					jQuery( 'input[name=tmp_' + taxonomy + ']', form ).val( '' );
					updateTaxonomies( taxonomy, form );
				}
				//return data;

			//alert(data.items[0].snippet.thumbnails.default.url);
			},
			error: function() {
				alert( 'Failed!' );
			},
			//    beforeSend: setHeader
		} );

		//               jQuery.getJSON('https://www.youtube.com/oembed?url=http://www.youtube.com/watch?v=ojCkgU5XGdg&format=json',function(data,status,xhr){
		//  alert(data.title);
		// data contains the JSON-Object below
		//});
	} else if ( strpos( url, 'vimeo' ) > 0 ) {
		return 'vimeo';
	} else {
		return 'unknown';
	}
};

setYouTubetitle = function( getfieldid, setfieldid, descid, tagid ) {
//alert("WORK DAMNIT");
//alert(getfieldid);
	var url = jQuery( '[id^=' + getfieldid + ']' ).val();

	//alert(url);

	var videoid = url.match( /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/ );

	//alert(videoid);

	jQuery.ajax( {

		url: 'https://www.googleapis.com/youtube/v3/videos?id=' + videoid + '&key=AIzaSyBv-Ulsg2kwwxUq2JOfvdIM5GOWG52iOJE&fields=items(snippet(title,description,thumbnails,tags))&part=snippet',
		//    data: myData,
		//    type: 'GET',
		//    crossDomain: true,
		dataType: 'jsonp',
		success: function( data ) {
			//	var info = new Array();
			//	info['title'] = data.items[0].snippet.title;
			//	info['thumb_url'] = data.items[0].snippet.thumbnails.default.url;

			jQuery( '[id^=' + setfieldid + ']' ).val( data.items[ 0 ].snippet.title );
			jQuery( '[id^=' + descid + ']' ).val( data.items[ 0 ].snippet.description );
			//alert(data.items[0].snippet.description);
			jQuery( '#video_thumb' ).attr( 'src', data.items[ 0 ].snippet.thumbnails.standard.url );
			jQuery( 'input[name=post_auto_thumb]' ).attr( 'value', data.items[ 0 ].snippet.thumbnails.standard.url );
			jQuery( '[id^=' + tagid + ']' ).val( data.items[ 0 ].snippet.tags[ 0 ] );
			//alert(data.items[0].snippet.thumbnails.default.url);
			jQuery( '#video_header_addon' ).text( 'YouTube ' ).show( 'slow' );
		},
		error: function() { },
		//    beforeSend: setHeader
	} );
};

setWebsiteMeta = function( getfieldid, titlefieldid, descid, tagid ) {
//alert("WORK DAMNIT");
//alert(getfieldid);
	var url = jQuery( '[id^=' + getfieldid + ']' ).val();

	//alert(url);

	var data = {
		action: 'ps_get_external_meta',
		url: url, // We pass php values differently!
	};

	//alert(videoid);

	//setTimeout(function () {
	//jQuery.post(ajax_object.ajax_url, data, function(response) {

	jQuery.ajax( {
		type: 'post',
		timeout: 20000,
		url: ajax_object.ajax_url,
		dataType: 'json',
		data: { action: 'ps_get_external_meta', url: url },
		error: function( textStatus, textStatus2 ) {
			console.log( 'Got this from the server: ' + textStatus + ' ' + textStatus );
		},
		success: function( response ) {
			var obj = jQuery.parseJSON( response );
			//alert('Got this from the server: ' + response);
			//alert( obj.keywords );
			console.log( 'test' );
			console.log( 'Got this from the server: ' + response );

			//jQuery('#webpage_thumb_div').html('<img id="webpage_thumb" src="">Loading');
			//jQuery('#webpage_thumb').attr("src","/wp-includes/js/tinymce/skins/lightgray/img/loader.gif");

			if ( obj.hasOwnProperty( [ 'twitter:title' ] ) ) {
				jQuery( '[id^=' + titlefieldid + ']' ).val( obj[ 'twitter:title' ] );
			} else if ( obj.hasOwnProperty( [ 'title' ] ) ) {
				jQuery( '[id^=' + titlefieldid + ']' ).val( obj.title );
			} else if ( obj.hasOwnProperty( 'author' ) ) {
				jQuery( '[id^=' + titlefieldid + ']' ).val( obj.author );
			}

			if ( obj.hasOwnProperty( 'description' ) ) {
				var tmpeditorid = jQuery( 'div.mce-tinymce' ).attr( 'id' );
				var tmpfieldid = jQuery( '.cred-field-post_content textarea' ).attr( 'id' );
				tinymce.execCommand( 'mceRemoveEditor', true, tmpfieldid );
				jQuery( '[id^=' + descid + ']' ).val( obj.description );
				tinymce.execCommand( 'mceAddEditor', true, tmpfieldid );
				tinyMCE.execCommand( 'mceRepaint' );
			}

			if ( obj.hasOwnProperty( 'keywords' ) ) {
				//jQuery('[id^='+tagid+']').val(obj.keywords);
				//var thiz = $(".cred-taxonomy.cred-taxonomy-post_tag .btn.btn-default.wpt-taxonomy-add-new.js-wpt-taxonomy-add-new.wpt-form-button.form-button");
				//  var thiz = $(".cred-taxonomy.cred-taxonomy-post_tag .btn.btn-default.wpt-taxonomy-add-new.js-wpt-taxonomy-add-new.wpt-form-button.form-button");
				//        taxonomy = thiz.data("taxonomy");
				//setTaxonomy("post_tag", "test");

				var taxonomy = 'post_tag';
				var form = jQuery( '.cred-taxonomy.cred-taxonomy-post_tag .btn.btn-default.wpt-taxonomy-add-new.js-wpt-taxonomy-add-new.wpt-form-button.form-button' ).closest( 'form' );
				//var tmp_tax = jQuery("input[name=tmp_" + taxonomy + "]", form).val();
				console.log( obj.keywords );
				console.log( obj.keywords );
				var tmp_tax = obj.keywords;
				var rex = /<\/?(a|abbr|acronym|address|applet|area|article|aside|audio|b|base|basefont|bdi|bdo|bgsound|big|blink|blockquote|body|br|button|canvas|caption|center|cite|code|col|colgroup|data|datalist|dd|del|details|dfn|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hgroup|hr|html|i|iframe|img|input|ins|isindex|kbd|keygen|label|legend|li|link|listing|main|map|mark|marquee|menu|menuitem|meta|meter|nav|nobr|noframes|noscript|object|ol|optgroup|option|output|p|param|plaintext|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|source|spacer|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video|wbr|xmp)\b[^<>]*>/ig;
				tmp_tax = _.escape( tmp_tax.replace( rex, '' ) ).trim();
				if ( tmp_tax.trim() === '' ) {
					return;
				}
				var tax = jQuery( 'input[name=' + taxonomy + ']', form ).val();
				var arr = tax.split( ',' );
				if ( jQuery.inArray( tmp_tax, arr ) !== -1 ) {
					return;
				}
				var toadd = ( tax === '' ) ? tmp_tax : tax + ',' + tmp_tax;
				jQuery( 'input[name=' + taxonomy + ']', form ).val( toadd );
				jQuery( 'input[name=tmp_' + taxonomy + ']', form ).val( '' );
				updateTaxonomies( taxonomy, form );
			}

			//}, 10000); //timeout
		},

	} );

	// jQuery.support.cors                 = true;

	jQuery( '#webpage_thumb_div' ).html( '<img id="webpage_thumb" src="">Loading' );
	jQuery( '#webpage_thumb' ).attr( 'src', '/wp-includes/js/tinymce/skins/lightgray/img/loader.gif' );

	data = {
		action: 'ps_get_site_shot',
		//'url':'http://theeverythingcompany.com'
		url: 'http://api.screenshotlayer.com/api/capture?access_key=8c0fc9f06a01db70f6b8d0e163df85ba&url=' + url + '&viewport=1360x900&width=300&format=png', // We pass php values differently!
	};

	//console.log("http://api.screenshotlayer.com/api/capture?access_key=8c0fc9f06a01db70f6b8d0e163df85ba&url="+url+"&viewport=1360x900&width=300&format=png");
	//console.log("data:" + data);

	jQuery.post( ajax_object.ajax_url, data, function( response ) {
		//		alert('Got this from the server: ' + response);

		//jQuery('#webpage_thumb').attr('src', response);
		//jQuery('#video_only').html(response);

		//jQuery('#video_only').html('<iframe id="iframe1">');
		//jQuery('#webpage_thumb').contents().find('html').html(response);
		jQuery( '#webpage_thumb_div' ).html( response );

		//var iframe = document.createElement('iframe');
		//var html = response;
		//iframe.src = 'data:text/html;charset=utf-8,' + encodeURI(html);
		//document.body.appendChild(iframe);
		//console.log('iframe.contentWindow =', iframe.contentWindow);
	} );

	/*jQuery.ajax({
    type: "GET",
    url: "https://api.screenshotlayer.com/api/capture?access_key=8c0fc9f06a01db70f6b8d0e163df85ba&url="+url+"&viewport=1360x900&width=300&format=png",
    //url: '@Url.action("Captcha","Login")',
    //dataType:"image/png",
    beforeSend: function () {
        alert("going");
      },
    success: function (data) {
        //jQuery('#CaptchaImg').attr('src', data);
        alert("loaded: "+url);
        console.log(data, url);
        jQuery('#webpage_thumb').attr("src","https://api.screenshotlayer.com/api/capture?access_key=8c0fc9f06a01db70f6b8d0e163df85ba&url="+url+"&viewport=1360x900&width=300&format=png");
        jQuery('input[name=web_post_auto_thumb]').attr("value","https://api.screenshotlayer.com/api/capture?access_key=8c0fc9f06a01db70f6b8d0e163df85ba&url="+url+"&viewport=1360x900&width=700&format=png");
        //jQuery('#webpage_thumb').attr('src', data);
      },
      error: function(xhr, status, error) {
  var err = eval("(" + xhr.responseText + ")");
  alert(err.Message + error + xhr);
}
 });*/

	//jQuery('#webpage_thumb').attr("src","http://api.screenshotlayer.com/api/capture?access_key=8c0fc9f06a01db70f6b8d0e163df85ba&url="+url+"&viewport=1360x900&width=300&format=png");
	jQuery( 'input[name=web_post_auto_thumb]' ).attr( 'value', 'http://api.screenshotlayer.com/api/capture?access_key=8c0fc9f06a01db70f6b8d0e163df85ba&url=' + url + '&viewport=1360x900&width=700&format=png' );
};

parseresults = function( data ) {
	var title = data.entry.title.$t;
	var description = data.entry.media$group.media$description.$t;
	var viewcount = data.entry.yt$statistics.viewCount;
	var author = data.entry.author[ 0 ].name.$t;
	alert( title );
	alert( '<b>Description</b>: ' + description );
	alert( '<b>Author</b>: ' + author + '<br /><b>Views</b>: ' + viewcount );
	// getComments(data.entry.gd$comments.gd$feedLink.href + '&max-results=50&alt=json', 1);
};

jQuery( document ).ready( function( $ ) {
//getYouTubeInfo();

/*
	$('input[name=peoples_post_meta_video_link]').live('keyup', function (index, value) {
		var value = $(this).val();
		setTimeout(function(){
			if ($(this).val() === value)
			{
					console.log('going');
			}
		},1000);
	});
*/

/*
==================================================================
						Problem / Solution Buttons
==================================================================
*/

	function refresh_pstype_buttons() {
		$( 'div.cred-field-post_pstype select > option' ).each( function() {
			$( '#' + this.value + '_button_trigger i' ).removeClass( 'fa-check' );

			if ( this.selected ) {
				$( '#' + this.value + '_button_trigger i' ).addClass( 'fa-check' );
			}
		} );
	}

	$( 'div.cred-field-post_pstype select > option' ).each( function() {
		//alert(this.text + ' ' + this.value);
		//$(this).text(this.text + '<i class="" aria-hidden="true"></i>');

		$( 'div.cred-field-post_pstype' ).append( '<button id="' + this.value + '_button_trigger" pstype="' + this.index + '" class="btn btn-small btn-success">' + this.text + '<br><i class="fa" aria-hidden="true"></i></button>' );

		if ( this.selected ) {
			$( '#' + this.value + '_button_trigger i' ).addClass( 'fa-check' );
		} else {
			$( '#' + this.value + '_button_trigger i' ).removeClass( 'fa-check' );
		}

		var temp_value = this.value;

		$( '#' + this.value + '_button_trigger' ).on( 'click', function( e ) {
		//e.preventDefault();
		//alert("index? " + $('#'+this.value+'_button_trigger').attr('pstype'));
			$( 'div.cred-field-post_pstype select' ).val( temp_value );
			refresh_pstype_buttons();
			e.stopPropagation();
			e.preventDefault();
			return false;
		} );
	} );

//$("._statusDDL").val('2');
} );

jQuery( document ).ready( function( $ ) {
//    $( ".cred-field-post_title" ).hide();

	$( '#clear_content' ).click( function( e ) {
		$( '.cred-field-post_content textarea' ).val( '' );
		e.stopPropagation();
		e.preventDefault();
		return false;
	} );

	$( '#type_webpage' ).click( function() {
		show_fields_webpage();
	} );

	$( '#type_video' ).click( function() {
		show_fields_video();
	} );

	$( '#type_original' ).click( function() {
		show_fields_original();
	} );

/*$( "#back_button" ).click(function() {
	fields_goback();
});*/
} );

var fields_goback, show_fields_webpage, show_fields_video, show_fields_image, show_fields_original;

function reload_tinyMCE() {
	jQuery( '.wpt-wysiwyg' ).each( function( index ) {
		var $area = jQuery( this ),
			area_id = $area.prop( 'id' );
		console.log( $area );
		if ( typeof area_id !== 'undefined' ) {
			console.log( 'removing ' + area_id );
			tinyMCE.remove();
			tinyMCE.init( tinyMCEPreInit.mceInit[ area_id ] );
			console.log( 'init -- ' + area_id );
			var quick = quicktags( tinyMCEPreInit.qtInit[ area_id ] );
			Toolset.add_qt_editor_buttons( quick, area_id );
		}
	} );

	if ( typeof tinyMCE !== 'undefined' ) {
		console.log( 'init2' );
		var $area = jQuery( 'textarea[name="post_content"]' ),
			area_id = $area.prop( 'id' );
		if ( typeof area_id !== 'undefined' ) {
			console.log( 'removing2 ' + area_id );
			tinyMCE.remove();
			console.log( 'init -- ' + area_id );
			tinyMCE.init( tinyMCEPreInit.mceInit[ area_id ] );
			var quick = quicktags( tinyMCEPreInit.qtInit[ area_id ] );
			Toolset.add_qt_editor_buttons( quick, area_id );
		}
	}
}

fields_goback = function() {

};

show_fields_webpage = function() {
	jQuery( document ).ready( function( $ ) {
		$( '.video_only' ).html( '' );

		$( 'div.penci-page-header h1' ).html( 'Add Webpage' );

		$( '.cred-field-post_content label.cred-label' ).html( 'Excerpt' );
		$( '.cred-field-post_content span.ui-icon.ui-icon-help' ).attr( 'title', 'Excerpt instructions' );

		$( '#post_buttons' ).hide( 50 );
		$( '#post_fields' ).show2( 100 );
		$( '.cred-field-post_url' ).show( 100 );

		$( '.cred-field-post_url input' ).focus();
		$( '.cred-field-post_url input' ).click();
		//$('.cred-field-post_url input').attr("value",'');
		//alert($('.cred-field-post_url input').attr("id"));

		//$('.cred-field-post_url input').keypress(function (e) {
		$( '.cred-field-post_url input' ).keydown( function( e ) {
			var key = e.which;
			//alert(key);
			if ( key === 13 ) { // the enter key code
				//alert("going");
				$( '.cred-field-post_url button' ).click();
				//return;
			}
		} );

		$( '.cred-field-post_url button' ).click( function() {
		//alert("going");
			setWebsiteMeta( $( '.cred-field-post_url input' ).attr( 'id' ),
				$( '#cred-field-post_title  input' ).attr( 'id' ),
				$( '.cred-field-post_content textarea' ).attr( 'id' ),
				$( '.cred-taxonomy-post_tag input' ).attr( 'id' ) );

			//reload_tinyMCE();

			$( '#post_fields_stage2' ).show( 100 );
			$( '#post_fields_stage3' ).show2( 100 );
			$( '#web_post_auto_thumb_div' ).show( 100 );
			//$(this).html("Refresh External Content");
			$( this ).remove();
			return false;
		} );

		$( '#post_fields' ).show2( 100, function() {
			//$( "#post_fields .webpage, #post_fields .all" ).show(100);
		} );

		$( '#post_fields .webpage, #post_fields .all' ).show( 100 );
	} );
};

show_fields_video = function() {
	jQuery( document ).ready( function( $ ) {
		$( '.webpage_only' ).html( '' );

		$( 'div.penci-page-header h1' ).html( 'Add Video' );

		$( '.cred-field-post_content label.cred-label' ).html( 'Description' );
		$( '.cred-field-post_content span.ui-icon.ui-icon-help' ).attr( 'title', 'Description instructions' );

		$( '#post_buttons' ).hide( 50 );
		$( '#post_fields' ).show2( 100 );
		$( '.cred-field-post_video_url' ).show( 100 );

		$( '.cred-field-post_video_url input' ).focus();
		$( '.cred-field-post_video_url input' ).click();
		//$('.cred-field-post_url input').attr("value",'');
		//alert($('.cred-field-post_url input').attr("id"));

		//$('.cred-field-post_url input').keypress(function (e) {
		$( '.cred-field-post_video_url input' ).keydown( function( e ) {
			var key = e.which;
			//alert(key);
			if ( key === 13 ) { // the enter key code
				//alert("going");
				$( '.cred-field-post_video_url button' ).click();
				//return;
			}
		} );
		//peoples_post_meta_video_link

		$( '.cred-field-post_video_url button' ).click( function() {
			//alert("going");

			//var url = jQuery('[id^='+getfieldid+']').val();
			//var videoinfo = getVideoInfo($('.cred-field-post_video_url input').val());

			getVideoInfo( $( '.cred-field-post_video_url input' ).val(), function( videoinfo ) {
				console.log( 'this' );
				console.dir( videoinfo );

				if ( videoinfo.status === 'success' ) {
					console.log( 'going 1' );
					console.dir( videoinfo );

					console.log( videoinfo.description );

					jQuery( '#cred-field-post_title  input' ).val( videoinfo.title );
					//jQuery('#cred-field-post_title  input').val("test");
					var tmpeditorid = jQuery( 'div.mce-tinymce' ).attr( 'id' );
					var tmpfieldid = jQuery( '.cred-field-post_content textarea' ).attr( 'id' );
					tinymce.execCommand( 'mceRemoveEditor', true, tmpfieldid );
					jQuery( '.cred-field-post_content textarea' ).val( videoinfo.description );
					tinymce.execCommand( 'mceAddEditor', true, tmpfieldid );
					tinyMCE.execCommand( 'mceRepaint' );

					/*if (typeof tinyMCE !== 'undefined') {
        console.log('init2');
            var $area = jQuery('textarea[name="post_content"]'),
                    area_id = $area.prop('id');
    jQuery('#'+area_id).setContent(videoinfo.description);
    }*/

					//reload_tinyMCE();

					jQuery( '#webpage_thumb_div' ).html( '<div class="overlay"></div>' +
	'<img id="webpage_thumb" src="' + videoinfo.thumbnail.small + '">' +
	'<span class="click">Click to Replace</span>' );
					//jQuery('#webpage_thumb').attr("src","/wp-includes/js/tinymce/skins/lightgray/img/loader.gif");

					jQuery( document ).ready( function( $ ) {
						$( '#webpage_thumb_div .click' ).mouseover( function() {
							$( '.overlay' ).animate( {
								opacity: 0.5,
							}, 100 );
						} ).mouseout( function() {
							$( '.overlay' ).animate( {
								opacity: 0,
							}, 100 );
						} );

						$( '#webpage_thumb_div .click' ).click( function() {
							$( '#web_post_cred_thumb_div' ).show( 100 );

							$( '#webpage_thumb_div' ).hide( 100 );
							$( 'input[name=web_post_auto_thumb]' ).attr( 'value', '' );
						} );
					} );

					jQuery( 'input[name=web_post_auto_thumb]' ).attr( 'value', videoinfo.thumbnail.large );

					if ( videoinfo.hasOwnProperty( 'embed' ) ) {
						$( '#video_embed' ).append( '<div>' + videoinfo.embed + '</div>' );
						$( '#video_embed_div' ).show( 100 );
					}

					if ( videoinfo.hasOwnProperty( 'keywords' ) ) {
						//jQuery('[id^='+tagid+']').val(obj.keywords);
						//var thiz = $(".cred-taxonomy.cred-taxonomy-post_tag .btn.btn-default.wpt-taxonomy-add-new.js-wpt-taxonomy-add-new.wpt-form-button.form-button");
						//  var thiz = $(".cred-taxonomy.cred-taxonomy-post_tag .btn.btn-default.wpt-taxonomy-add-new.js-wpt-taxonomy-add-new.wpt-form-button.form-button");
						//        taxonomy = thiz.data("taxonomy");
						//setTaxonomy("post_tag", "test");

						var taxonomy = 'post_tag';
						var form = jQuery( '.cred-taxonomy.cred-taxonomy-post_tag .btn.btn-default.wpt-taxonomy-add-new.js-wpt-taxonomy-add-new.wpt-form-button.form-button' ).closest( 'form' );
						//var tmp_tax = jQuery("input[name=tmp_" + taxonomy + "]", form).val();
						console.log( videoinfo.keywords );
						console.log( videoinfo.keywords );
						//var tmp_tax = obj.keywords;
						var tmp_tax = jQuery.map( videoinfo.keywords, function( value, index ) {
							return [ value ];
						} );
						//var rex = /<\/?(a|abbr|acronym|address|applet|area|article|aside|audio|b|base|basefont|bdi|bdo|bgsound|big|blink|blockquote|body|br|button|canvas|caption|center|cite|code|col|colgroup|data|datalist|dd|del|details|dfn|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hgroup|hr|html|i|iframe|img|input|ins|isindex|kbd|keygen|label|legend|li|link|listing|main|map|mark|marquee|menu|menuitem|meta|meter|nav|nobr|noframes|noscript|object|ol|optgroup|option|output|p|param|plaintext|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|source|spacer|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video|wbr|xmp)\b[^<>]*>/ig;
						//tmp_tax = _.escape(tmp_tax.replace(rex, "")).trim();
						//if (tmp_tax.trim() === "")
						//return;
						var tax = jQuery( 'input[name=' + taxonomy + ']', form ).val();
						//var arr = tax.toString();
						var arr = tax.split( ',' );
						if ( jQuery.inArray( tmp_tax, arr ) !== -1 ) {
							return;
						}
						var toadd = ( tax === '' ) ? tmp_tax : tax + ',' + tmp_tax;
						jQuery( 'input[name=' + taxonomy + ']', form ).val( toadd );
						jQuery( 'input[name=tmp_' + taxonomy + ']', form ).val( '' );
						updateTaxonomies( taxonomy, form );
					}
				} else {
					console.log( 'Failed to get video info' );
				}
			} );

			/*			setYouTubeInfo($('.cred-field-post_video_url input').attr("id"),
				$('#cred-field-post_title  input').attr("id"),
				$('.cred-field-post_content textarea').attr("id"),
				$('.cred-taxonomy-post_tag input').attr("id"));
*/

			$( '#post_fields_stage2' ).show( 100 );
			$( '#post_fields_stage3' ).show2( 100 );
			$( '#web_post_auto_thumb_div' ).show( 100 );
			//$(this).html("Refresh External Content");
			$( this ).remove();

			$( '#post_fields_stage2' ).show( 100 );
			$( '#post_fields_stage3' ).show2( 100 );
			$( '#web_post_auto_thumb_div' ).show( 100 );
			//$(this).html("Refresh External Content");
			$( this ).remove();

			return false;
		} );

		$( '#post_fields' ).show2( 100, function() {
			//$( "#post_fields .webpage, #post_fields .all" ).show(100);
		} );

		$( '#post_fields .webpage, #post_fields .all' ).show( 100 );
	} );
};

show_fields_image = function() {

};

show_fields_original = function() {
	jQuery( document ).ready( function( $ ) {
		$( '#web_post_auto_thumb_div, #web_post_cred_thumb_div' ).show( 100 );
		$( '.video_only, .webpage_only, .cred-field-post_url' ).html( '' );
		//$('.webpage_only').html('');

		$( 'div.penci-page-header h1' ).html( 'Add Your Own Content' );

		$( '.cred-field-post_content label.cred-label' ).html( 'Your Content' );
		$( '.cred-field-post_content span.ui-icon.ui-icon-help' ).attr( 'title', 'Excerpt instructions' );

		$( '#post_buttons' ).hide( 50 );
		$( '#post_fields_stage2, .web_post_cred_thumb_div, .original' ).show( 100 );
		$( '#post_fields_stage3' ).show2( 100 );
		//$( "#post_fields_stage2, .web_post_cred_thumb_div, .original" ).removeClass('hide');
		//$( "#post_fields_stage2, .web_post_cred_thumb_div, .original" ).fadeIn();
		//		$( "#post_fields_stage2, .web_post_cred_thumb_div, .original" ).css("opacity","1");
		//$( ".cred-field-post_url" ).html('');
		$( '.cred-field-_featured_image' ).css( 'min-height', '155px' );
		//$('.cred-field-post_url input').focus();
		//$('.cred-field-post_url input').click();
		//$('.cred-field-post_url input').attr("value",'');
		//alert($('.cred-field-post_url input').attr("id"));

		//$('.cred-field-post_url input').keypress(function (e) {
		$( '.cred-field-post_url input' ).keydown( function( e ) {
			var key = e.which;
			//alert(key);
			if ( key === 13 ) { // the enter key code
				//alert("going");
				$( '.cred-field-post_url button' ).click();
				//return;
			}
		} );

		$( '.cred-field-post_url button' ).click( function() {
		//alert("going");
			setWebsiteMeta( $( '.cred-field-post_url input' ).attr( 'id' ),
				$( '#cred-field-post_title  input' ).attr( 'id' ),
				$( '.cred-field-post_content textarea' ).attr( 'id' ),
				$( '.cred-taxonomy-post_tag input' ).attr( 'id' ) );

			//reload_tinyMCE();

			$( '#post_fields_stage2' ).show( 100 );
			$( '#post_fields_stage3' ).show2( 100 );
			$( '#web_post_auto_thumb_div' ).show( 100 );
			//$(this).html("Refresh External Content");
			$( this ).remove();
			return false;
		} );

		$( '#post_fields' ).show2( 100, function() {
			//$( "#post_fields .webpage, #post_fields .all" ).show(100);
		} );
		$( '#post_fields .webpage, #post_fields .all' ).show( 100 );
	} );
};

